import Screen from '@/styles/Themes/Screen';
import styled from 'styled-components';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from '@/styles/Themes/Text';
import Palette from '@/styles/Themes/Palette';
import { DropdownArrow } from '@/shared/images/icons/DropdownArrow';

export const Container = styled.div`
    background-color: ${cssVars.bg_sand_dark3};
    border-radius: 16px;
    padding: 20px;

    ${Screen.ipad} {
        padding: 30px 40px;
    }
`;

export const Title = styled.h4`
    ${Text.Full.heading3}
    color: ${cssVars.fg_gray1_white};
    margin: 0 0 12px;
`;

export const ContentBlock = styled.div`
    ${Screen.ipad} {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
    }
`;

export const Content = styled.div`
    ${Screen.ipad} {
        margin-right: 30px;
        flex: 1;
    }
`;

export const AuthorName = styled.div`
    ${Text.Full.heading4}
    margin: 0 0 12px;
    color: ${Palette.sand.darkSand};
`;

export const Description = styled.div`
    ${Text.Full.large.regular}
    color: ${cssVars.fg_gray2_gray3};
    margin-bottom: 16px;
`;

export const AuthorLink = styled.a`
    ${Text.Full.medium.medium}
    color: ${cssVars.fg_gray1_white};
    cursor: pointer;
    display: flex;

    :hover {
        text-decoration: underline;
    }
`;

export const MainImage = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
`;

export const AuthorImage = styled.div`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    border: solid 1px ${Palette.sand.darkSand};
    background-color: ${cssVars.bg_gray4_dark1};
    flex-shrink: 0;
    margin-bottom: 12px;
    flex: none;

    ${Screen.ipad} {
        width: 130px;
        height: 130px;
    }
`;

export const Arrow = styled(DropdownArrow)`
    height: 18px;
    width: 18px;
    transform: rotate(-90deg);
    fill: ${cssVars.fg_gray1_white};

    margin: 0 4px;
    ${Screen.ipad} {
        height: 20px;
        width: 20px;
    }
`;
